var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_5616370",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.672 61.055-16.921 66.708 50.761.362 36.276-67.07z",
    fill: "#dbe2ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m110.8 61.055h-13.012l-36.276 36.574-30.252 30.5h90.886a5.623 5.623 0 0 0 5.734-6.9l-10.537-55.53c-.489-2.587-3.418-4.644-6.543-4.644z",
    fill: "#f9b958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m122.149 128.13h-90.891l3.851-3.881h82.417a5.621 5.621 0 0 0 5.73-6.908l-10.535-55.527a3.19 3.19 0 0 0 -.142-.539 6.2 6.2 0 0 1 4.765 4.419l10.534 55.528a5.621 5.621 0 0 1 -5.729 6.908z",
    fill: "#f1a846",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.672 61.055h-10.472c-3.13 0-6.059 2.057-6.548 4.638l-10.532 55.53a5.623 5.623 0 0 0 5.734 6.9h25.406l30.252-30.5z",
    fill: "#a5ceac"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m35.088 124.269-3.83 3.861h-25.407a5.621 5.621 0 0 1 -5.729-6.908l.152-.8a5.609 5.609 0 0 0 5.577 3.85z",
    fill: "#91b898",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m79.474-.13a31.526 31.526 0 0 0 -31.523 31.523c0 15.124 23.8 51.32 30.039 60.555a1.788 1.788 0 0 0 2.968 0c6.242-9.235 30.042-45.431 30.042-60.555a31.526 31.526 0 0 0 -31.526-31.523zm0 51.7a20.113 20.113 0 1 1 20.113-20.115 20.114 20.114 0 0 1 -20.113 20.113z",
    fill: "#f05461"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a8d788dad1b843be09ac65e839e815b3.svg";
export { ForwardRef as ReactComponent };